var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12L13.3333 12.7294C12.9797 13.1161 12.5001 13.3333 12.0001 13.3333C11.5001 13.3333 11.0205 13.1161 10.6669 12.7294C10.3128 12.3434 9.83334 12.1267 9.33347 12.1267C8.8336 12.1267 8.35411 12.3434 8 12.7294",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.2171C2 11.8909 2 11.7279 2.03684 11.5744C2.0695 11.4384 2.12338 11.3083 2.19648 11.189C2.27894 11.0545 2.39424 10.9392 2.62484 10.7086L11 2.3334C11.5523 1.78112 12.4477 1.78112 13 2.3334C13.5523 2.88569 13.5523 3.78112 13 4.3334L4.62486 12.7086C4.39425 12.9392 4.27895 13.0545 4.1444 13.1369C4.0251 13.21 3.89504 13.2639 3.75899 13.2966C3.60554 13.3334 3.44248 13.3334 3.11636 13.3334H2V12.2171Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2d5b0cffba5104d03e7a0d4f552ff691.svg";
export { ForwardRef as ReactComponent };